/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { AutoGenerateWorkQueuesCommand } from '../model'
// @ts-ignore
import type { RenameWorkQueue } from '../model'
// @ts-ignore
import type { SaveWorkQueueCommand } from '../model'
// @ts-ignore
import type { StartWorkQueue } from '../model'
// @ts-ignore
import type { StopWorkQueue } from '../model'
// @ts-ignore
import type { WorkQueueDto } from '../model'
// @ts-ignore
import type { WorkQueueSaveResponseDto } from '../model'
/**
 * WorkQueueApi - axios parameter creator
 */
export const WorkQueueApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {AutoGenerateWorkQueuesCommand} [autoGenerateWorkQueuesCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    autoGenerateWorkQueues: async (
      autoGenerateWorkQueuesCommand?: AutoGenerateWorkQueuesCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkQueue/autoGenerateWorkQueues`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        autoGenerateWorkQueuesCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get: async (
      carrierVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkQueue`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {RenameWorkQueue} [renameWorkQueue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rename: async (
      renameWorkQueue?: RenameWorkQueue,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkQueue/rename`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        renameWorkQueue,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {SaveWorkQueueCommand} [saveWorkQueueCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    save: async (
      saveWorkQueueCommand?: SaveWorkQueueCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkQueue/saveCraneSplit`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saveWorkQueueCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {StartWorkQueue} [startWorkQueue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    start: async (
      startWorkQueue?: StartWorkQueue,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkQueue/start`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        startWorkQueue,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {StopWorkQueue} [stopWorkQueue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stop: async (
      stopWorkQueue?: StopWorkQueue,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkQueue/stop`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        stopWorkQueue,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * WorkQueueApi - functional programming interface
 */
export const WorkQueueApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = WorkQueueApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {AutoGenerateWorkQueuesCommand} [autoGenerateWorkQueuesCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async autoGenerateWorkQueues(
      autoGenerateWorkQueuesCommand?: AutoGenerateWorkQueuesCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.autoGenerateWorkQueues(
        autoGenerateWorkQueuesCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkQueueApi.autoGenerateWorkQueues']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkQueueDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(carrierVisitId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkQueueApi.get']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {RenameWorkQueue} [renameWorkQueue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rename(
      renameWorkQueue?: RenameWorkQueue,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rename(renameWorkQueue, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkQueueApi.rename']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {SaveWorkQueueCommand} [saveWorkQueueCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async save(
      saveWorkQueueCommand?: SaveWorkQueueCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkQueueSaveResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.save(saveWorkQueueCommand, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkQueueApi.save']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {StartWorkQueue} [startWorkQueue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async start(
      startWorkQueue?: StartWorkQueue,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkQueueDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.start(startWorkQueue, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkQueueApi.start']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {StopWorkQueue} [stopWorkQueue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async stop(
      stopWorkQueue?: StopWorkQueue,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkQueueDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.stop(stopWorkQueue, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkQueueApi.stop']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * WorkQueueApi - factory interface
 */
export const WorkQueueApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = WorkQueueApiFp(configuration)
  return {
    /**
     *
     * @param {AutoGenerateWorkQueuesCommand} [autoGenerateWorkQueuesCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    autoGenerateWorkQueues(
      autoGenerateWorkQueuesCommand?: AutoGenerateWorkQueuesCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .autoGenerateWorkQueues(autoGenerateWorkQueuesCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<WorkQueueDto>> {
      return localVarFp.get(carrierVisitId, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {RenameWorkQueue} [renameWorkQueue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rename(renameWorkQueue?: RenameWorkQueue, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.rename(renameWorkQueue, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {SaveWorkQueueCommand} [saveWorkQueueCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    save(
      saveWorkQueueCommand?: SaveWorkQueueCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WorkQueueSaveResponseDto> {
      return localVarFp
        .save(saveWorkQueueCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {StartWorkQueue} [startWorkQueue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    start(
      startWorkQueue?: StartWorkQueue,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WorkQueueDto> {
      return localVarFp.start(startWorkQueue, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {StopWorkQueue} [stopWorkQueue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stop(
      stopWorkQueue?: StopWorkQueue,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WorkQueueDto> {
      return localVarFp.stop(stopWorkQueue, options).then(request => request(axios, basePath))
    },
  }
}

/**
 * WorkQueueApi - object-oriented interface
 */
export class WorkQueueApi extends BaseAPI {
  /**
   *
   * @param {AutoGenerateWorkQueuesCommand} [autoGenerateWorkQueuesCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public autoGenerateWorkQueues(
    autoGenerateWorkQueuesCommand?: AutoGenerateWorkQueuesCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkQueueApiFp(this.configuration)
      .autoGenerateWorkQueues(autoGenerateWorkQueuesCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [carrierVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public get(carrierVisitId?: number, options?: RawAxiosRequestConfig) {
    return WorkQueueApiFp(this.configuration)
      .get(carrierVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {RenameWorkQueue} [renameWorkQueue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rename(renameWorkQueue?: RenameWorkQueue, options?: RawAxiosRequestConfig) {
    return WorkQueueApiFp(this.configuration)
      .rename(renameWorkQueue, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {SaveWorkQueueCommand} [saveWorkQueueCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public save(saveWorkQueueCommand?: SaveWorkQueueCommand, options?: RawAxiosRequestConfig) {
    return WorkQueueApiFp(this.configuration)
      .save(saveWorkQueueCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {StartWorkQueue} [startWorkQueue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public start(startWorkQueue?: StartWorkQueue, options?: RawAxiosRequestConfig) {
    return WorkQueueApiFp(this.configuration)
      .start(startWorkQueue, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {StopWorkQueue} [stopWorkQueue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public stop(stopWorkQueue?: StopWorkQueue, options?: RawAxiosRequestConfig) {
    return WorkQueueApiFp(this.configuration)
      .stop(stopWorkQueue, options)
      .then(request => request(this.axios, this.basePath))
  }
}
